<template>
  <modal
    name="dialog-info"
    v-on="$listeners"
    class="dialog-info"
    @before-open="onBeforeOpen"
  >
    <template>
      <div class="flex flex-col h-full bg-white py-4 space-y-3.5">
        <div class="text-base font-bold">{{params.title}}</div>
        <div class="text-sm">{{params.subtitle}}</div>
        <div class="flex flex-row justify-center space-x-3.5">
          <Button
            v-for="(action, actionIndex) in params.actions"
            :key="action.name"
            :palette="action.palette"
            :class="action.classes"
            @click="onActionClick(actionIndex)"
          >
            {{action.text}}
          </Button>
        </div>
      </div>
    </template>
  </modal>
</template>
<script>
import Button from '@/components/UI/Button.vue';

export default {
  name: 'DialoInfo',
  components: {
    Button,
  },
  data() {
    return {
      defaults: {
        title: this.$t('common.action-confirmation'),
        subtitle: this.$t('common.execute-action'),
        actions: [
          {
            name: 'delete',
            text: this.$t('common.delete'),
            palette: 'danger-bg',
            classes: '',
            onClick: () => {},
          },
          {
            name: 'cancel',
            text: this.$t('common.delete'),
            palette: 'transparent-bg',
            onClick: () => {},
          },
        ],
      },
      params: {
        title: null,
        subtitle: null,
        actions: [],
      },
    };
  },
  methods: {
    onBeforeOpen({ params }) {
      this.params = params;
    },
    onClosed() {
      this.params = {
        title: null,
        subtitle: null,
        actions: [],
      };
    },
    onActionClick(index) {
      const action = this.params.actions[index];
      if (typeof action?.onClick === 'function') {
        action.onClick();
      }
    },
  },
};
</script>
<style lang="scss">
.dialog-info{
  .vm--modal {
    width: 350px!important;
    left: 50%!important;
    top: 50%!important;
    transform: translate(-50%, -50%);
    height: auto !important;
  }
}
</style>
